import React from 'react';
import ReactDOM from 'react-dom';
//import {BrowserRouter} from 'react-router-dom';

import {MagicContext} from '../../hooks';
import RoutedMapsightApp from '../routing';

import {BrowserRouter} from './browser-router';

/**
 * @param {import("../types").Magic} magic
 */
export default function createMapsightUiBrowserDomRenderer(magic) {
	/**
	 * Browser renderer (DOM) with re-hydration
	 *
	 * @type {import("@mapsight/ui/src/js/index").MapsightUiRenderer}
	 * @inheritDoc {import("@mapsight/ui/src/js/index").MapsightUiRenderer}
	 */
	return function mapsightUiBrowserDomRenderer(container, props, hydrate = false) {
		const app = (
			<BrowserRouter>
				<MagicContext.Provider value={magic || {}}>
					<RoutedMapsightApp {...props} />
				</MagicContext.Provider>
			</BrowserRouter>
		);

		return ReactDOM[hydrate ? 'hydrate' : 'render'](app, container);
	};
}
